<template>
	<div>
		<!--========= Tabs With Filters=============-->
		<tabs animation="slide" :only-fade="false" alignment="center" :is-fullwidth="true"  class="primary-tabs">
			<tab-pane :label="t('pending')" selected>
				<div v-if="agentDesktop" class="p10 has-text-weight-bold">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<p class="has-text-centered has-text-grey">{{ t('product_image')}}</p>
								</div>
								<div class="column is-9 has-text-right">
									<p class="has-text-centered has-text-grey">{{ t('product_name')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('product_price')}}</p>
								</div>
								<div class="column is-8">
									<p class="has-text-centered has-text-grey">{{ t('details')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-2">
						</div>
					</div>
				</div>
				<div v-if="agentDesktop" v-for="product in pendingProducts" class="p10 has-text-weight-bold border-top-warning">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<a rel="preload" :href="product.link">
										<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
											<lazy-load
											src="/front/img/spinner.svg"
											:lazy-src="product.image"
											:lazy-srcset="product.image"
											background-color="transparent"
											:alt="product.product_name" class="hvr-grow"
											/>
										</figure>
									</a>
								</div>
								<div class="column is-9 has-text-centered">
									<div class="display-table height-full w-100">
										<div class="display-table-cell vertical-align">
											<p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary is-size-6">
							<div class="columns height-full">
								<div class="column is-4">
									<div class="display-table height-full has-text-centered w-100">
										<div class="display-table-cell vertical-align">
											<p>{{product.subtotal + ' ' + t('currency')}}</p>
										</div>
									</div>
								</div>
								<div class="column is-8">
									<div class="display-table height-full has-text-centered w-100">
										<div class="display-table-cell vertical-align">
											<div class="field">
												<div class="control has-text-centered">
													<button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="column is-2">
							<div class="display-table height-full has-text-centered w-100">
								<div class="display-table-cell vertical-align">
									<a rel="preload" href="#" class="mr-auto button is-rounded is-block is-primary has-text-weight-bold" @click.prevent="deleteProduct(product)">
										{{ t('cancel') }}
									</a>
									<p class="has-text-warning">
										{{ t('wait_confirm') }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!agentDesktop" class="orders-table-mobile">
					<div v-for="product in pendingProducts" class="p10 has-text-weight-bold border-top-warning">
						<div class="columns is-mobile">
							<div class="column is-3-tablet is-4-mobile">
								<a rel="preload" :href="product.link">
									<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
										<lazy-load
										src="/front/img/spinner.svg"
										:lazy-src="product.image"
										:lazy-srcset="product.image"
										background-color="transparent"
										:alt="product.product_name"
										class="mr-auto hvr-grow"
										:lazy-height="60"
										:lazy-width="60"
										/>
									</figure>
								</a>
							</div>
							<div class="column is-9-tablet is-8-mobile">
								<p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
								<div class="columns is-mobile is-multiline">
									<div class="column is-12">
										<p class="has-text-grey">{{ t('product_price')}} : <span class="has-text-primary">{{product.subtotal + ' ' + t('currency')}}</span></p>
										<p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
									</div>
									<div class="column is-12 has-text-centered">
										<a rel="preload" href="#" class="mr-auto button is-rounded is-block is-primary has-text-weight-bold" @click.prevent="deleteProduct(product)">
											{{ t('cancel') }}
										</a>
										<p class="has-text-warning">
											{{ t('wait_confirm') }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</tab-pane>
			<tab-pane :label="t('done')">
				<div v-if="agentDesktop" class="p10 has-text-weight-bold">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<p class="has-text-centered has-text-grey">{{ t('product_image')}}</p>
								</div>
								<div class="column is-9 has-text-right">
									<p class="has-text-centered has-text-grey">{{ t('product_name')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<p class="has-text-centered has-text-grey">{{ t('product_price')}}</p>
								</div>
								<div class="column is-8">
									<p class="has-text-centered has-text-grey">{{ t('details')}}</p>
								</div>
							</div>
						</div>
						<div class="column is-2">
						</div>
					</div>
				</div>
				<div v-if="agentDesktop" v-for="product in doneProducts" class="p10 has-text-weight-bold border-top-warning">
					<div class="columns">
						<div class="column is-5">
							<div class="columns height-full">
								<div class="column is-3">
									<a rel="preload" :href="product.link">
										<figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
											<lazy-load
											src="/front/img/spinner.svg"
											:lazy-src="product.image"
											:lazy-srcset="product.image"
											background-color="transparent"
											:alt="product.product_name" class="hvr-grow"
											/>
										</figure>
									</a>
								</div>
								<div class="column is-9 has-text-centered">
									<div class="display-table height-full w-100">
										<div class="display-table-cell vertical-align">
											<p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="column is-5 has-text-primary">
							<div class="columns height-full">
								<div class="column is-4">
									<div class="display-table height-full has-text-centered w-100">
										<div class="display-table-cell vertical-align">
											<p>{{product.subtotal + ' ' + t('currency')}}</p>
										</div>
									</div>
								</div>
								<div class="column is-8">
									<div class="display-table height-full has-text-centered w-100">
										<div class="display-table-cell vertical-align">
											<button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="column is-2">
							<div class="display-table height-full has-text-centered w-100">
								<div class="display-table-cell vertical-align">
									<a rel="preload" href="#" v-if="product.rate==0" class="mr-auto button is-rounded is-block is-primary has-text-weight-bold" @click.prevent="addRate(product)">
										{{ t('rate_product')}}
									</a>
									<star-rating v-if="product.rate !=0" v-bind:increment="1"
									:read-only="true"
									:rating="product.rate"
									v-bind:max-rating="5"
									inactive-color="#ffffff"
									border-color="#f9ca2f"
									:border-width="2"
									active-color="#f9ca2f"
									v-bind:star-size="18" :rtl="sitelocale == 'ar' ? true : false">
								</star-rating>
							</div>
						</div>
            </div>
          </div>
			  </div>
        <div v-if="!agentDesktop" class="orders-table-mobile is-size-7">
          <div v-for="product in doneProducts" class="p10 has-text-weight-bold border-top-warning">
            <div class="columns is-mobile">
              <div class="column is-3-tablet is-4-mobile">
                <a rel="preload" :href="product.link">
                  <figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
                    <lazy-load
                    src="/front/img/spinner.svg"
                    :lazy-src="product.image"
                    :lazy-srcset="product.image"
                    background-color="transparent"
                    :alt="product.product_name"
                    class="mr-auto hvr-grow"
                    :lazy-height="60"
                    :lazy-width="60"
                    />
                  </figure>
                </a>
              </div>
              <div class="column is-9-tablet is-8-mobile">
                <p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
                <div class="columns is-mobile is-multiline">
                  <div class="column is-12">
                    <p class="has-text-grey">{{ t('product_price')}}  : <span class="has-text-primary">{{product.subtotal + ' ' + t('currency')}}</span></p>
                    <p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
                  </div>
                  <div class="column is-12 has-text-centered">
                    <a rel="preload" href="#" v-if="product.rate==0" class="mr-auto button is-rounded is-block is-primary has-text-weight-bold" @click.prevent="addRate(product)">
                      {{ t('rate_product') }}
                    </a>
                    <star-rating v-if="product.rate !=0" v-bind:increment=".5"
                    :read-only="true"
                    :rating="product.rate"
                    v-bind:max-rating="5"
                    inactive-color="#ffffff"
                    border-color="#f9ca2f"
                    :border-width="2"
                    active-color="#f9ca2f"
                    v-bind:star-size="18" :rtl="sitelocale == 'ar' ? true : false">
                  </star-rating>
                  <p class="has-text-warning">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
	    </tab-pane>
      <tab-pane :label="t('deleted')">
        <div v-if="agentDesktop" class="p10 has-text-weight-bold">
          <div class="columns">
            <div class="column is-5">
              <div class="columns height-full">
                <div class="column is-3">
                  <p class="has-text-centered has-text-grey">{{ t('product_image') }}</p>
                </div>
                <div class="column is-9 has-text-right">
                  <p class="has-text-centered has-text-grey">{{ t('product_name') }}</p>
                </div>
              </div>
            </div>
            <div class="column is-5 has-text-primary is-size-6">
              <div class="columns height-full">
                <div class="column is-4">
                  <p class="has-text-centered has-text-grey">{{ t('product_price') }}</p>
                </div>
                <div class="column is-8">
                  <p class="has-text-centered has-text-grey">{{ t('details')}}</p>
                </div>
              </div>
            </div>
            <div class="column is-2">
            </div>
          </div>
        </div>
        <div  v-if="agentDesktop" v-for="product in deletedProducts" class="p10 has-text-weight-bold border-top-warning">
          <div class="columns">
            <div class="column is-5">
              <div class="columns height-full">
                <div class="column is-3">
                  <a rel="preload" :href="product.link">
                    <figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
                      <lazy-load
                      src="/front/img/spinner.svg"
                      :lazy-src="product.image"
                      :lazy-srcset="product.image"
                      background-color="transparent"
                      :alt="product.product_name" class="hvr-grow"
                      />
                    </figure>
                  </a>
                </div>
                <div class="column is-9 has-text-centered">
                  <div class="display-table height-full w-100">
                    <div class="display-table-cell vertical-align">
                      <p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-5 has-text-primary is-size-6">
              <div class="columns height-full">
                <div class="column is-4">
                  <div class="display-table height-full has-text-centered w-100">
                    <div class="display-table-cell vertical-align">
                      <p>{{product.subtotal + ' ' + t('currency')}}</p>
                    </div>
                  </div>
                </div>
                <div class="column is-8">
                  <div class="display-table height-full has-text-centered w-100">
                    <div class="display-table-cell vertical-align">
                      <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div class="display-table height-full has-text-centered w-100">
                <div class="display-table-cell vertical-align">

                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!agentDesktop" class="orders-table-mobile is-size-7">
          <div v-for="product in deletedProducts" class="p10 has-text-weight-bold border-top-warning">
            <div class="columns is-mobile">
              <div class="column is-3-tablet is-4-mobile">
                <a rel="preload" :href="product.link">
                  <figure class="overflow-hidden image image-contain-height height-100 has-background-white radius-lg p15 box-shadow">
                    <lazy-load
                    src="/front/img/spinner.svg"
                    :lazy-src="product.image"
                    :lazy-srcset="product.image"
                    background-color="transparent"
                    :alt="product.product_name"
                    class="mr-auto hvr-grow"
                    :lazy-height="60"
                    :lazy-width="60"
                    />
                  </figure>
                </a>
              </div>
              <div class="column is-9-tablet is-8-mobile">
                <p class="has-text-primary link-hvr-primary">{{product.product_name}}</p>
                <div class="columns is-mobile is-multiline">
                  <div class="column is-12">
                    <p class="has-text-grey">{{ t('product_price')}}  : <span class="has-text-primary">{{product.subtotal + ' ' + t('currency')}}</span></p>
                    <p class="has-text-grey">{{ t('details')}} : <button class="has-text-primary button show-button is-size-5" @click="showDetails(product)"><i class="fas fa-eye"></i></button></p>
                  </div>
                  <div class="column is-6 has-text-centered">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab-pane>
    </tabs>
    <!--========= Two Modals Combined=============-->
    <div v-if="selectedProduct" class="modal" :class="{ 'is-active': controlRateModal || controlDeleteModal || controlDetailsModal }">
      <div class="modal-background is-white"></div>
      <div class="card modal-content">
        <div class="overflow-hidden has-text-centered">
          <div class="has-background-warning has-text-white has-text-weight-bold p5">
            <p class="has-text-centered is-size-6">
              <template v-if="controlRateModal">
                {{ t('rate_product') }}
              </template>
              <template v-if="controlDeleteModal">
                {{ t('cancel') }}
              </template>
              <template v-if="controlDetailsModal">
                {{ t('details') }}
              </template>

            </p>
          </div>
          <div class="p25" v-if="!controlDetailsModal">
            <figure class="mr-auto image image-contain-height is-96x96">
              <lazy-load
              src="/front/img/spinner.svg"
              :lazy-src="selectedProduct.image"
              :lazy-srcset="selectedProduct.image"
              background-color="transparent"
              alt="slider" class="hvr-grow"
              />
            </figure>
            <p class="has-text-warning is-size-6 has-text-weight-bold has-text-centered mb30">{{selectedProduct.product_name}}</p>
              <star-rating v-if="controlRateModal" v-bind:increment="1"
                :read-only="false"
                v-bind:max-rating="5"
                inactive-color="#ffffff"
                border-color="#f9ca2f"
                :border-width="2"
                active-color="#f9ca2f"
                v-bind:star-size="25" :rtl="sitelocale == 'ar' ? true : false" name="rate" v-model="form.rate" v-validate="{ required: true }">
              </star-rating>
            <p v-if="controlRateModal" v-show="errors.has('rate')" class="help is-danger has-text-centered">{{ errors.first('rate') }}</p>
            <button v-if="controlRateModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateForm">{{ t('rate')}}</button>
            <button v-if="controlDeleteModal" class="button is-primary is-rounded has-text-weight-bold pr30 pl30 mt60" @click="validateDelete()">{{ t('cancel_confirm')}}</button>
          </div>
          <div v-else class="p25 has-text-right">
            <div class="columns is-vcentered">
              <div class="column is-3">
                <figure class="mr-auto image image-contain-height is-128x128">
                  <lazy-load
                  src="/front/img/spinner.svg"
                  :lazy-src="selectedProduct.image"
                  :lazy-srcset="selectedProduct.image"
                  background-color="transparent"
                  alt="slider" class="hvr-grow"
                  />
                </figure>
              </div>
              <div class="column is-9">
                <p class="mb20 has-text-warning is-size-6 has-text-weight-bold">{{selectedProduct.product_name}}</p>
                <p class="has-text-grey"> {{ t('category_name') }}  : <span class="has-text-primary">{{ selectedProduct.category_name }}</span></p>
                <p class="has-text-grey">{{ t('merchant_name') }}  : <span class="has-text-primary">{{ selectedProduct.merchant_name }}</span></p>
                <p class="has-text-grey">{{ t('product_price') }}  : <span class="has-text-primary">{{ selectedProduct.subtotal }} {{ t('currency')}}</span></p>
                <p v-if="selectedProduct.category_type === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ selectedProduct.quantity }}</span></p>
                <p v-if="selectedProduct.category_type === 'date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ selectedProduct.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ selectedProduct.finish_date }}
                  </span>
                </p>
                <p v-if="selectedProduct.category_type === 'date_time'" class="has-text-grey">
                  {{ t('date_time')}}:
                  <span class="has-text-primary">
                    {{ selectedProduct.start_date }} {{ selectedProduct.start_time }}
                  </span>
                </p>
                <p v-if="selectedProduct.category_type === 'fixed_date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ selectedProduct.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ selectedProduct.finish_date }}
                  </span>
                </p>
                <p class="has-text-grey">{{ t('total')}} : <span class="has-text-primary">{{ selectedProduct.total }} {{ t('currency')}}</span></p>
              </div>
            </div>
          </div>
      </div>
    </div>
    <button class="modal-close is-large has-background-warning" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>
<script>
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator } from 'vee-validate';
	import trans from "../translation/orders.json";
	import { Tabs, TabPane } from 'vue-bulma-tabs'
	import axios from "axios";
	export default {
		name: "UserProducts",
		components: {
			Tabs,
			TabPane
		},
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			products:{
				required: true
			},
			agentDesktop:{
				type:Boolean,
				required: true
			}
		},
		locales: trans,
		data: () => ({
			controlRateModal:false,
			controlDeleteModal:false,
      controlDetailsModal:false,
			selectedProduct:null,
			form:{
				rate:null,
				id:null
			},
			pendingProducts:[],
			doneProducts:[],
			deletedProducts:[],


		}),
		mounted() {
			this.$translate.setLang(this.sitelocale);
			/*-----------filtering-----------*/
			let pendingProducts = this.pendingProducts;
			let doneProducts = this.doneProducts;
			let deletedProducts = this.deletedProducts;
			this.products.map(function(item){
				if(item.status == 'pending'){
					pendingProducts.push(item);
				}else if(item.status == 'delivered'){
					doneProducts.push(item);
				}
				else if(item.status == 'canceled'){
					deletedProducts.push(item);
				}

			});
		},
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
			});
			this.$validator.localize('en', {
				attributes: trans.en,
			});
			Validator.localize(this.sitelocale);
		},
		methods: {
			addRate(product){
				this.selectedProduct = product;
				this.form.id = this.selectedProduct.id;
				this.controlRateModal = true;
			},
      showDetails(product){
        this.selectedProduct = product;
        this.controlDetailsModal = true;
      },
			closeModal(){
				this.controlRateModal = false;
				this.controlDeleteModal = false;
        this.controlDetailsModal = false;
				this.selectedProduct = null;
				this.productRate=0
			},
			deleteProduct(product){
				this.selectedProduct = product;
				this.controlDeleteModal= true;
			},
			validateForm(){
				let editedIndex = this.doneProducts.indexOf(this.selectedProduct);
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.isDisabled = true;
						axios.post(`/${this.sitelocale}/client/rate/${this.selectedProduct.id}`, this.form)
						.then(response => {
							this.showAlert('success' ,  response.data.message , '' , '');
							let new_data = response.data.order;
							Object.assign(this.doneProducts[editedIndex], new_data);
							this.closeModal();
						})
						.catch(error => {
							this.showAlert('error',
								`${this.$translate.text('error_in_data')}`,
								'text',
								`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error[0]}</li>`).join(' ')+`</ul>`
								);
							this.isDisabled=false;
							console.clear();
						})
						.then(()=>{
							setTimeout(()=>{
							}, 3500);
						});
					}
				});
			},
			validateDelete(){
				let editedIndex = this.pendingProducts.indexOf(this.selectedProduct);
				let data = {
					'status': 'canceled',
				};
				axios.patch(`/${this.sitelocale}/client/orders/${this.selectedProduct.id}`, data)
				.then(response => {
					let new_data = response.data.order;
					this.deletedProducts.push(new_data);
					this.pendingProducts.splice(editedIndex, 1);
					this.showAlert('success', response.data.message, '', '');
					this.closeModal();
				})
				.catch(error => {
					this.showAlert('error', error.response.data.message, '', '');
				});
			},
			showAlert(type , title , text , html){
				this.$swal({
					type: type,
					title: title,
					text: text,
					html: html,
					showConfirmButton: false,
					timer:2000,
					customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
					backdrop: `
					rgba(36, 140, 204, 0.5)
					`
				});
			}
		},

	};
</script>
<style scoped>
	.show-button{
		border:0;
		height: auto;
	}
</style>
